import {reqWithToken} from './requestHelper';

export async function getFormsHistory(){
    return (await reqWithToken('api/pebooking/history')).data;
}